import React from 'react';
import { IntentConfig } from 'src/shared/intent';
import { action } from '../model/paymentResultIntent';
import { action as subscribe } from '../model/subscriptionIntent';

export const paymentResult: IntentConfig = {
  action,
  Component: React.lazy(() => import('../model/usePaymentResult').then((m) => ({ default: m.PaymentResultRunner }))),
};

export const subscribeIntent: IntentConfig = {
  action: subscribe,
  Component: React.lazy(() => import('../model/subscribeRunner')),
};
